import Radium from "radium";
import React from "react";
import _ from "lodash";

import { searchStyles } from "@common/styles";

export interface ISearchBarProps {
  activeOnly: boolean;
  placeholder: string;
  searchText: string;
  onShowActiveChange: (onlyShowActive: boolean) => void;
  onSearchInputChanged: (searchTerm: string) => void;
}

class SearchBar extends React.Component<ISearchBarProps> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  public render() {
    const searchBarActiveStyle = {
      ...searchStyles.searchBarItem,
      "@media (min-width: 480px)": { marginLeft: "5px", display: "flex" }
    };
    const searchBarContainerStyle = {
      ...searchStyles.searchBarContainer,
      "@media (min-width: 1024px)": { marginRight: 0, marginBottom: 0 },
      "@media (min-width: 1080px)": { marginRight: "20px" }
    };
    const searchBarItemStyle = {
      ...searchStyles.searchBarItem,
      ...{ height: "34px", flexGrow: 1 }
    };
    const searchInputStyle = {
      ...searchStyles.searchInput,
      ...{ height: "30px", flexGrow: 1 }
    };

    return (
      <div className="searchBarContainer" style={searchBarContainerStyle}>
        <div className="searchBar" style={searchBarItemStyle as any}>
          <input
            type="text"
            placeholder={this.props.placeholder}
            onChange={e => this.props.onSearchInputChanged(e.target.value)}
            value={this.props.searchText}
            style={searchInputStyle}
          />
        </div>
        <div className="searchActive" style={searchBarActiveStyle as any}>
          <input
            type="checkbox"
            id="isActiveInput"
            onChange={e => this.props.onShowActiveChange(e.target.checked)}
            checked={this.props.activeOnly}
          />
          <label
            htmlFor="isActiveInput"
            className="searchActiveLabel"
            style={searchStyles.searchActiveLabel as any}
          >
            Vis kun aktive brukere
          </label>
        </div>
      </div>
    );
  }
}

export default Radium(SearchBar);
